import { useEffect, useState } from "react";
import { CategoryInternalNotesResult } from "~/common/Store/models/ProductListing";
import { getCategoryInternalNotes } from "../requests";
import { useDynamicData } from "~/common/hooks/useDynamicData";

export function useInternalNotes(categoryId: number, isInternal: boolean) {
  const defaultInternalNotesData = {
    categoryId: 0,
    link: "",
  };
  const [internalNotesData, setInternalNotesData] =
    useState<CategoryInternalNotesResult>(defaultInternalNotesData);

  const isInitialized = useDynamicData();

  useEffect(() => {
    async function fetchNotes() {
      const result = await getCategoryInternalNotes(categoryId);
      if (!result.isError && result.value) {
        setInternalNotesData(result.value);
      } else {
        setInternalNotesData(defaultInternalNotesData);
      }
    }
    if (isInternal && isInitialized) {
      fetchNotes();
    }
  }, [isInternal, isInitialized, categoryId]);

  return internalNotesData;
}
